import {State} from '../types'
import {NativeModal} from '../components/modals/constants'

export const getModalType = (state: State) => {
  return state.modals.modalType || ''
}

export const isSeatingModalOpen = (state: State) => getModalType(state) === NativeModal.SEATING_PLAN
